import { useGLTF } from "@react-three/drei";
import { images, videos, audios, subtitles } from "../assets/assets";

export async function preloadSecondaryAssets() {
  // Modèle 3D
  useGLTF.preload("./models/scene_secondary_4_baked.glb");

  const imagesUrls = [
    images.moonImg,
    images.starsBackground1,
    images.starsBackground2,
    images.starsBackground3,
    images.logo,
    images.endPhoto,
    images.endDoorBackground,
    images.singleDoor,
    images.smoke,
  ];

  await Promise.all(
    imagesUrls.map(
      (src) =>
        new Promise((resolve) => {
          const img = new window.Image();
          img.src = src;
          img.onload = resolve;
          img.onerror = resolve;
        })
    )
  );

  const audioUrls = [
    // RoomScene
    audios.swoosh_telescope_in,
    audios.swoosh_telescope_out,
    audios.swoosh_cloud_to_room,
    audios.entree_chambre,
    audios.debut_telescope,
    audios.focus_telescope,
    // MoonUI
    audios.lune_trouvee,
    audios.focal_simple_clic,
    // Timelapse
    audios.timelapse,
    // TuyauScene
    audios.pipe_tourner,
    audios.liquide,
    audios.fin_carburant,
    audios.encouragement_emotion,
    audios.mathis_error,
    audios.fond_sonor_machine,
    audios.levier,
    // BuzzerScene / FuseeScene
    audios.fin_experience,
    audios.rocket_launch,
    audios.heart_beating,
    audios.heart_beating_appears,
    audios.instruction_buzzer,
  ];
  await Promise.all(
    audioUrls.map(
      (src) =>
        new Promise((resolve) => {
          const audio = new window.Audio();
          audio.preload = "auto";
          audio.src = src;
          // Il arrive parfois que canplaythrough ne soit jamais appelé, donc on met un fallback timeout
          let resolved = false;
          const done = () => {
            if (!resolved) {
              resolved = true;
              resolve();
            }
          };
          audio.oncanplaythrough = done;
          audio.onerror = done;
          setTimeout(done, 2000);
        })
    )
  );

  // Vidéos Timelapse
  const videosUrls = [videos.video];
  await Promise.all(
    videosUrls.map(
      (src) =>
        new Promise((resolve) => {
          const video = document.createElement("video");
          video.preload = "auto";
          video.src = src;
          video.muted = true; // Sinon certains navigateurs refusent le preload
          let resolved = false;
          const done = () => {
            if (!resolved) {
              resolved = true;
              resolve();
            }
          };
          video.oncanplaythrough = done;
          video.onerror = done;
          setTimeout(done, 2000);
        })
    )
  );

  // Sous-titres (MoonUI, TuyauScene, etc.)
  const subtitlesUrls = [
    subtitles.entree_chambre,
    subtitles.debut_telescope,
    subtitles.focus_fusee,
    subtitles.timelapse,
    subtitles.fin_telescope,
    subtitles.focus_telescope,
    subtitles.fin_carburant,
    subtitles.encouragement_emotion,
    subtitles.mathis_error,
    subtitles.fin_experience,
    subtitles.instruction_buzzer,
  ];
  await Promise.all(
    subtitlesUrls.map((src) =>
      fetch(src)
        .then((res) => (res.ok ? res.text() : null))
        .catch(() => null)
    )
  );
}
